import styled from 'styled-components';

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  height: 120px;
  box-shadow: 0px 1px 6px 1px #00000026;
  padding: 25px;
`;

export { HeaderContainer };
